(() => {
  function initialize(root) {
    if (root.dataset.occasionReady) return;
    root.dataset.occasionReady = 'true';
    const find = (suffix) => root.querySelector(`[id$="-${suffix}"]`);
    const grid = find('products');
    const cards = [...grid.querySelectorAll('.sfw-product')];
    const sort = find('sort');
    const filters = [...root.querySelectorAll('[data-filter]')];
    const showAll = find('show-all');
    const count = find('count');
    const countLabel = Number(grid.dataset.pages) > 1 ? root.dataset.countPageLabel : root.dataset.countLabel;
    let active = 'all';
    let expanded = false;

    function matches(card, filter) {
      const favor = card.dataset.favorUnit === 'true';
      if (filter === 'all') return true;
      return favor && Number(card.dataset.price) < 500;
    }
    filters.forEach((button) => {
      if (button.dataset.filter === 'all') return;
      const matching = cards.filter((card) => matches(card, button.dataset.filter));
      button.hidden = matching.length === 0 || matching.length === cards.length || !matching.some((card) => card.dataset.available === 'true');
    });
    root.querySelector('.sfw-filters').hidden = filters.filter((button) => !button.hidden).length < 2;

    function render() {
      const items = cards.filter((card) => matches(card, active));
      items.sort((a, b) => {
        const priceDifference = Number(a.dataset.price) - Number(b.dataset.price);
        const originalOrder = Number(a.dataset.index) - Number(b.dataset.index);
        if (sort.value === 'low') return priceDifference || originalOrder;
        if (sort.value === 'high') return -priceDifference || originalOrder;
        return originalOrder;
      });
      const visible = expanded ? items : items.slice(0, 6);
      const visibleSet = new Set(visible);
      cards.forEach((card) => { card.hidden = !visibleSet.has(card); });
      items.forEach((card) => grid.append(card));
      count.textContent = countLabel.replace('__VISIBLE__', String(visible.length)).replace('__TOTAL__', String(items.length));
      find('empty').hidden = items.length !== 0 || cards.length === 0;
      showAll.hidden = items.length <= 6;
      showAll.setAttribute('aria-expanded', String(expanded));
      showAll.setAttribute('aria-controls', grid.id);
      showAll.querySelector('span').textContent = expanded ? root.dataset.fewerLabel : root.dataset.showLabel.replace('__COUNT__', String(items.length));
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === active)));
    }
    filters.forEach((button) => button.addEventListener('click', () => {
      active = button.dataset.filter;
      expanded = false;
      render();
    }));
    sort.addEventListener('change', render);
    showAll.addEventListener('click', () => {
      expanded = !expanded;
      render();
      if (!expanded) find('styles').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    find('reset').addEventListener('click', () => {
      active = 'all';
      expanded = false;
      render();
      filters[0].focus();
    });

    const tabs = [...root.querySelectorAll('[role="tab"]')];
    function selectTab(tab) {
      tabs.forEach((button) => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        const panel = root.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
        panel.hidden = !selected;
        panel.tabIndex = 0;
      });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabs[next]);
        tabs[next].focus();
      });
    });

    const header = document.querySelector('sticky-header');
    const setHeaderSpacing = () => {
      const height = Math.ceil(header?.getBoundingClientRect().height || 0);
      const overlay = header?.classList.contains('header-transparent');
      root.style.setProperty('--sfw-scroll-offset', `${height + 24}px`);
      root.style.setProperty('--sfc-header-space', `${overlay ? height : 0}px`);
    };
    setHeaderSpacing();
    if (header && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(setHeaderSpacing);
      observer.observe(header);
      const unload = (event) => {
        if (event.target.contains(root)) {
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
    }
    root.querySelectorAll('[data-sfc-enhance]').forEach((element) => { element.hidden = false; });
    if (tabs.length) selectTab(tabs[0]);
    render();
  }
  const initializeAll = (container) => {
    if (container.matches?.('[data-occasion-section]')) initialize(container);
    container.querySelectorAll('[data-occasion-section]').forEach(initialize);
  };
  initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
